import { r4Client, r4Error } from '@/services'

const CsvRoiReportsApi = {
  async fetchCsvRoiReports(dealerId) {
    try {
      const resp = await r4Client().get(`/api/v1/reports/csv/roi`, { params: { dealer_id: dealerId } })
      return resp.data
    } catch (error) {
      throw r4Error(error)
    }
  },

  async createCsvRoiReport(data) {
    try {
      const resp = await r4Client().post(`/api/v1/reports/csv/roi`, data)
      return resp.data
    } catch (error) {
      throw r4Error(error)
    }
  },

  async deleteCsvRoiReport(id) {
    try {
      const resp = await r4Client().delete(`/api/v1/reports/csv/roi/${id}`)
      return resp.data
    } catch (error) {
      throw r4Error(error)
    }
  }
}

export default CsvRoiReportsApi
